import axios from "./config";

/**
 * @function
 * @name getContracts
 * @description get Contracts
 * */
const getDocuments = (params = {}) => {
  const { selectedProcuringEntity, selectedProject } = params;
  return axios
    .get(`/documents`, {
      params: {
        page: params.page,
        per_page: 10,
        searchField: "name",
        searchQuery: params.searchQuery,
        project_id: selectedProject,
        council_id: selectedProcuringEntity,
      },
    })
    .then((response) => response.data);
};

/**
 * create new Contract
 *
 * @function
 * @name createContract
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const createDocument = (document) => {
  console.log({ document });
  return axios
    .post(`/documents`, document, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};

/**
 *
 * Edit contract from the API
 * @function
 * @name editDocument
 * @param {Object} id - Id of contract
 * @returns {Promise}
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const editDocument = (document, id) => {
  return axios
    .post(`/documents/${id}?_method=PUT`, document)
    .then((response) => response.data);
};

/**
 * detaches a Contract from list
 *
 * @function
 * @name deleteContract
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const deleteDocument = (id) => {
  return axios.delete(`documents/${id}`).then((response) => response.data);
};

export default {
  getDocuments,
  createDocument,
  editDocument,
  deleteDocument,
};
